'use strict';

module.exports = '2.19.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 118
// module chunks = 0 1